import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, Plus, Trash2 } from 'lucide-react';
import api, { isAuthenticated } from '../utils/api';
import { toast } from 'sonner';

const AdminCustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '', gender: 'Female', recent_purchase: '', notes: '' });
  const navigate = useNavigate();

  useEffect(() => { if (!isAuthenticated()) { navigate('/admin/login'); return; } fetchCustomers(); }, []);
  const fetchCustomers = async () => {
  try {
    const r = await api.get('/customers');
    const data = r.data;
    setCustomers(Array.isArray(data) ? data : data?.customers ?? data?.data ?? []);
  } catch(e) {
    setCustomers([]);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/customers', formData);
      toast.success('Customer added!');
      setShowForm(false);
      setFormData({ name: '', phone: '', gender: 'Female', recent_purchase: '', notes: '' });
      fetchCustomers();
    } catch (e) { toast.error('Error'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete?')) return;
    try { await api.delete(`/customers/${id}`); toast.success('Deleted'); fetchCustomers(); } catch(e) { toast.error('Error'); }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b sticky top-0 z-50">
        <div className="px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Link to="/admin/dashboard" className="text-[#E5A93C]"><ArrowLeft className="w-6 h-6" /></Link>
            <h1 className="font-heading text-xl font-bold text-[#2A0000]">Customer Management</h1>
          </div>
          <button onClick={() => setShowForm(true)} className="btn-primary flex items-center space-x-2"><Plus className="w-5 h-5" /><span>Add Customer</span></button>
        </div>
      </header>

      <div className="p-6">
        {showForm && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-lg w-full p-6">
              <h2 className="text-2xl font-bold mb-6">Add Customer</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <input type="text" placeholder="Name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required className="w-full px-4 py-2 border rounded" />
                <input type="tel" placeholder="Phone (+91...)" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} required className="w-full px-4 py-2 border rounded" />
                <select value={formData.gender} onChange={(e) => setFormData({ ...formData, gender: e.target.value })} className="w-full px-4 py-2 border rounded">
                  <option value="Female">Female</option><option value="Male">Male</option><option value="Other">Other</option>
                </select>
                <input type="text" placeholder="Recent purchase" value={formData.recent_purchase} onChange={(e) => setFormData({ ...formData, recent_purchase: e.target.value })} className="w-full px-4 py-2 border rounded" />
                <textarea placeholder="Notes" value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} rows={3} className="w-full px-4 py-2 border rounded" />
                <div className="flex space-x-2">
                  <button type="submit" className="flex-1 btn-primary">Save</button>
                  <button type="button" onClick={() => setShowForm(false)} className="flex-1 btn-outline">Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        <div className="bg-white rounded-lg border">
          <table className="w-full">
            <thead className="bg-gray-50 border-b"><tr><th className="px-6 py-3 text-left text-xs uppercase">ID</th><th className="px-6 py-3 text-left text-xs uppercase">Name</th><th className="px-6 py-3 text-left text-xs uppercase">Phone</th><th className="px-6 py-3 text-left text-xs uppercase">Gender</th><th className="px-6 py-3 text-left text-xs uppercase">Recent Purchase</th><th className="px-6 py-3 text-left text-xs uppercase">Actions</th></tr></thead>
            <tbody className="divide-y">
              {customers.map(c => (
                <tr key={c.customer_id}>
                  <td className="px-6 py-4 font-mono text-sm">{c.customer_id}</td>
                  <td className="px-6 py-4 font-medium">{c.name}</td>
                  <td className="px-6 py-4">{c.phone}</td>
                  <td className="px-6 py-4">{c.gender}</td>
                  <td className="px-6 py-4 text-sm text-gray-600">{c.recent_purchase || '-'}</td>
                  <td className="px-6 py-4"><button onClick={() => handleDelete(c.customer_id)}><Trash2 className="w-5 h-5 text-red-600" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          {customers.length === 0 && <p className="text-center text-gray-500 p-8">No customers yet</p>}
        </div>
      </div>
    </div>
  );
};

export default AdminCustomersPage;
